import { BadgeButton } from "src/components/base/badge";
import { BadgeColor } from "src/api/generated/frontend_internal_v1";
import { BadgeColorKey } from "src/components/base/color-picker";
import { HighlightTerm } from "src/components/highlight-term";
import { BuildingOffice2Icon } from "@heroicons/react/16/solid";

/**
 * The properties for {@link TenantBadge}
 */
export type TenantBadgeProps = {
    tenant: { name: string; uuid: string; badge_name: string; badge_color: BadgeColor };

    /**
     * A `<TenantBadge />` is a link to the tenant's page.
     * This optional argument overwrites this link's default target.
     */
    target?: "_blank" | "_parent" | "_self" | "_top";
};

export const TO_BADGE_KEY: Record<BadgeColor, BadgeColorKey> = {
    [BadgeColor.Red]: "red",
    [BadgeColor.Orange]: "orange",
    [BadgeColor.Amber]: "amber",
    [BadgeColor.Yellow]: "yellow",
    [BadgeColor.Lime]: "lime",
    [BadgeColor.Green]: "green",
    [BadgeColor.Emerald]: "emerald",
    [BadgeColor.Teal]: "teal",
    [BadgeColor.Cyan]: "cyan",
    [BadgeColor.Sky]: "sky",
    [BadgeColor.Blue]: "blue",
    [BadgeColor.Indigo]: "indigo",
    [BadgeColor.Violet]: "violet",
    [BadgeColor.Purple]: "purple",
    [BadgeColor.Fuchsia]: "fuchsia",
    [BadgeColor.Pink]: "pink",
    [BadgeColor.Rose]: "rose",
    [BadgeColor.Zinc]: "zinc",
};

/**
 * A badge showing the tenant's short name in its configured color,
 * linking to the tenant's page
 */
export function TenantBadge(props: TenantBadgeProps) {
    const { tenant, target } = props;

    return (
        <BadgeButton
            href={`/a/tenants/$tenantId/general`}
            params={{ tenantId: tenant.uuid }}
            color={TO_BADGE_KEY[tenant.badge_color]}
            title={tenant.name}
            target={target}
        >
            <BuildingOffice2Icon className={"size-4"} />
            <HighlightTerm value={tenant.badge_name} />
        </BadgeButton>
    );
}
